<template>
  <Listbox v-slot="{ open }" v-model="selectedValues" :disabled="disabled">
    <div class="group relative">
      <ListboxButton
        class=""
        :class="[
          open
            ? `border-${selectedOption.bg_color} pl-2`
            : `border-${selectedOption.bg_color}`,
          disabled
            ? 'cursor-default'
            : 'cursor-pointer group-hover:border-gray-200 group-hover:pl-2',
          'relative w-full rounded-md border border-transparent bg-transparent py-1 pl-0 text-left transition-all sm:text-sm'
        ]"
      >
        <div class="flex flex-row items-center gap-2">
          <span
            :data-tint="selectedOption.bg_color"
            class="bg-primary text-contrast-primary flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-sm"
          >
            <FontAwesomeIcon
              v-if="selectedOption.icon"
              :icon="['fal', selectedOption.icon]"
              size="xs"
            />
          </span>
          <span class="flex-1 truncate text-left">
            {{ selectedOption.name }}
          </span>
          <span
            class="flex-shrink-0 px-2 text-gray-500 opacity-0"
            :class="[
              open ? 'opacity-100' : '',
              disabled ? '' : 'group-hover:opacity-100'
            ]"
          >
            <FontAwesomeIcon :icon="['fal', 'chevron-down']" />
          </span>
        </div>
      </ListboxButton>

      <transition
        leave-active-class="transition duration-100 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <ListboxOptions
          class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm"
        >
          <ListboxOption
            v-for="option in options"
            v-slot="{ active, selected }"
            :key="option.value"
            :value="option.value"
            as="template"
          >
            <li
              :class="[
                active ? 'bg-primary-300 text-white' : 'text-gray-900',
                disabled ? 'cursor-default' : 'cursor-pointer',
                'relative px-2 py-1 select-none'
              ]"
            >
              <div class="flex flex-row items-center gap-2">
                <span
                  :data-tint="option.bg_color"
                  class="bg-primary text-contrast-primary flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-sm"
                >
                  <FontAwesomeIcon :icon="['fal', option.icon]" size="xs" />
                </span>
                <span
                  :class="[
                    selected ? 'font-medium' : 'font-normal',
                    'block truncate'
                  ]"
                  >{{ option.name }}</span
                >
              </div>
            </li>
          </ListboxOption>
        </ListboxOptions>
      </transition>
    </div>
  </Listbox>
</template>

<script>
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption
} from '@headlessui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'SelectMiniColored',
  components: {
    FontAwesomeIcon,
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption
  },
  props: {
    modelValue: {
      type: [String, Number],
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:modelValue'],
  computed: {
    selectedOption() {
      return (
        this.options.find((option) => option.value === this.modelValue) ?? {}
      )
    },
    selectedValues: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  }
}
</script>
